export default "__VITE_ASSET__C$CiBQCN__"